module.exports = __webpack_public_path__ + "assets/img/1.2e6849ab.png";